import { useCallback, useMemo } from 'react';
import useMetadata from '../useMetadata';

export default function useOfficeLocation() {
  const {
    state: metadataState,
    selectors: { selectOfficeLocation },
  } = useMetadata();

  // TODO: use this function in useOrderDetailsField.ts
  const displayOfficeLocation = useCallback(
    (locationCode) => {
      const officeLocation = selectOfficeLocation(metadataState, locationCode);
      return officeLocation ? officeLocation.locationName : '';
    },
    [metadataState, selectOfficeLocation],
  );

  return useMemo(
    () => ({
      displayOfficeLocation,
    }),
    [displayOfficeLocation],
  );
}
